import { render, staticRenderFns } from "./ReviewMyToggle.vue?vue&type=template&id=6bd1936e&scoped=true&"
import script from "./ReviewMyToggle.vue?vue&type=script&lang=js&"
export * from "./ReviewMyToggle.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMyToggle.vue?vue&type=style&index=0&id=6bd1936e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1936e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
